import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** Condición de papel que originó el aviso. */
export type BagtagPaperCondition = 'low' | 'empty';

/** Llave de título por condición; cuerpo y CTA son comunes a ambas. */
const TITLE_KEY_BY_CONDITION: Record<BagtagPaperCondition, string> = {
  low: 'bagtagLowPaper.title',
  empty: 'bagtagLowPaper.titleEmpty',
};

/**
 * Modal informativo de papel de la impresora Bag Tag.
 *
 * Cubre dos condiciones con el MISMO layout, iconografía, CTA y cierre:
 * - `low`   → nivel de papel bajo (107 MEDIA_LOW, CI-22506).
 * - `empty` → papel vacío (108 MEDIA_EMPTY, CVT20-14314).
 *
 * Es meramente informativo y NO bloqueante en ambas condiciones:
 * - No navega.
 * - No inicia, cancela ni termina ningún flujo.
 * - Se cierra con el CTA `Continuar` o con la `X` del shell `app-modal-refactor`.
 *
 * El ciclo de vida del episodio (una sola presentación, métrica única, reset con `0 OK`)
 * lo gobierna `BagtagMediaLowService`; este componente solo renderiza y acusa el cierre.
 */
@Component({
  selector: 'app-bagtag-low-paper-modal',
  templateUrl: './bagtag-low-paper-modal.component.html',
  styleUrls: ['./bagtag-low-paper-modal.component.scss'],
  standalone: false,
})
export class BagtagLowPaperModalComponent {
  /** Condición que se está avisando. Por defecto `low` (comportamiento previo). */
  @Input() condition: BagtagPaperCondition = 'low';

  readonly bodyKey = 'bagtagLowPaper.body';
  readonly ctaKey = 'bagtagLowPaper.cta';
  readonly icon = 'assets/images/Alert-icon.svg';

  constructor(private readonly activeModal: NgbActiveModal) {}

  get titleKey(): string {
    return TITLE_KEY_BY_CONDITION[this.condition];
  }

  /** CTA `Continuar`: acusa y cierra. No navega ni altera ningún flujo. */
  onContinue(): void {
    this.activeModal.close();
  }
}
